import styled from 'styled-components';

export const Measures = styled.div`
  background: white;
  min-height: 100%;
`
